module.exports = {
  data: function () {
    return {
      showLoginModal: false,
    }
  },

}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/intro-view.vue
// module id = 153
// module chunks = 0